import { Box } from '@mui/material';
import type { FC } from 'react';
import { PAGE_CONTENT_MAX_WIDTH_MD } from '~/constants';
import type { ReportOptionsProps } from './ReportOptions.types';
import { ReportOptionTile } from './ReportOptionTile';

export const ReportOptions: FC<ReportOptionsProps> = ({ options, selectedOption, handleOptionSelect }) => {
  return options.length ? (
    <Box>
      <Box maxWidth={PAGE_CONTENT_MAX_WIDTH_MD} mx="auto" px={{ xs: 3, lg: 0 }}>
        <Box
          display="grid"
          // TODO: Once we have enough report options, we can switch to a responsive grid
          // gridTemplateColumns={{ xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }}
          gridTemplateColumns="1fr"
          gap={3}
          justifyContent="center"
        >
          {options.map((option) => (
            <ReportOptionTile
              key={option.id}
              option={option}
              isSelected={selectedOption === option.id}
              handleOptionSelect={handleOptionSelect}
            />
          ))}
        </Box>
      </Box>
    </Box>
  ) : null;
};
